module.exports = __webpack_public_path__ + "assets/58b19bf4a03efcb7163b351592f66ba4.mp3";